import parse from 'html-react-parser';

export const handleHtmlStringToElement = (htmlString) => {
    return parse(htmlString); // returns React nodes
};

export const isProbablyHtml = (value) => {
    if (!value || typeof value !== 'string') {
        return false;
    }
    return /<\/?[a-z][\s\S]*>/i.test(value);
};

const escapeHtml = (value) => {
    return value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;');
};

const applyInlineMarkdown = (text) => {
    let html = escapeHtml(text);
    html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
    html = html.replace(/\*\*([^*]+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(
        /(^|[^*])\*(?!\s)([^*]+?)(?<!\s)\*(?!\*)/g,
        '$1<em>$2</em>'
    );
    return html;
};

const parseTableRow = (line) => {
    let parts = line.split('|').map((p) => p.trim());
    if (parts.length > 1 && parts[0] === '') {
        parts = parts.slice(1);
    }
    if (parts.length > 1 && parts[parts.length - 1] === '') {
        parts = parts.slice(0, -1);
    }
    return parts;
};

const isTableSeparatorLine = (line) => {
    return /^\s*\|?\s*:?-+:?\s*(\|\s*:?-+:?\s*)+\|?\s*$/.test(line);
};

export const renderMarkdownLitePreservingNewlines = (text) => {
    if (!text || typeof text !== 'string') {
        return '';
    }

    const lines = text.split(/\r\n|\r|\n/);
    const out = [];

    for (let i = 0; i < lines.length; i++) {
        const line = lines[i];

        const headingMatch = line.match(/^(#{1,6})\s+(.*)$/);
        if (headingMatch) {
            const level = headingMatch[1].length;
            const content = headingMatch[2] ?? '';
            const sizeClass =
                level === 1
                    ? 'text-xl'
                    : level === 2
                    ? 'text-lg'
                    : level === 3
                    ? 'text-base'
                    : 'text-sm';
            out.push(
                `<h${level} class="my-1 font-semibold text-slate-800 ${sizeClass}">${applyInlineMarkdown(
                    content
                )}</h${level}>`
            );
            continue;
        }

        const nextLine = i + 1 < lines.length ? lines[i + 1] : null;
        if (line.includes('|') && nextLine && isTableSeparatorLine(nextLine)) {
            const headerCells = parseTableRow(line);
            const rows = [];
            i = i + 2;
            for (; i < lines.length; i++) {
                const rowLine = lines[i];
                if (!rowLine.includes('|') || rowLine.trim() === '') {
                    i = i - 1;
                    break;
                }
                rows.push(parseTableRow(rowLine));
            }

            const thead = `<thead><tr>${headerCells
                .map(
                    (c) =>
                        `<th class="border border-slate-200 px-2 py-1 text-left font-semibold">${applyInlineMarkdown(
                            c
                        )}</th>`
                )
                .join('')}</tr></thead>`;

            const tbody = `<tbody>${rows
                .map(
                    (r) =>
                        `<tr>${r
                            .map(
                                (c) =>
                                    `<td class="border border-slate-200 px-2 py-1 align-top">${applyInlineMarkdown(
                                        c
                                    )}</td>`
                            )
                            .join('')}</tr>`
                )
                .join('')}</tbody>`;

            out.push(
                `<div class="my-1 overflow-x-auto"><table class="min-w-full border-collapse text-sm">${thead}${tbody}</table></div>`
            );
            continue;
        }

        if (line.trim() === '') {
            out.push('<br/>');
        } else {
            out.push(`${applyInlineMarkdown(line)}<br/>`);
        }
    }

    return out.join('');
};

export const renderAnswerStringToElement = (text) => {
    if (typeof text !== 'string') {
        return handleHtmlStringToElement(`${text}`);
    }

    if (isProbablyHtml(text)) {
        return handleHtmlStringToElement(text);
    }

    return handleHtmlStringToElement(renderMarkdownLitePreservingNewlines(text));
};

export const htmlToPlainText = (htmlString) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
};
